import { useFormContext } from "src/lib/templates";

export const useCreateFormContext = () =>
  useFormContext<any>();

